import { useEffect, useState } from "react";
import { PROMO_END_ISO } from "../content";

const END_TS = new Date(PROMO_END_ISO).getTime();

const calc = () => {
  const diff = Math.max(0, END_TS - Date.now());
  return {
    active: diff > 0,
    days: Math.floor(diff / 86400000),
    hours: Math.floor(diff / 3600000) % 24,
    minutes: Math.floor(diff / 60000) % 60,
    seconds: Math.floor(diff / 1000) % 60,
  };
};

export function usePromotion() {
  const [state, setState] = useState(calc);

  useEffect(() => {
    const tick = () => setState(calc());
    const id = setInterval(tick, 1000);
    document.addEventListener("visibilitychange", tick);
    return () => {
      clearInterval(id);
      document.removeEventListener("visibilitychange", tick);
    };
  }, []);

  return state;
}
